export default __webpack_public_path__ + "static/media/HIW-wr-1.ff846004.webp";